module.exports = __webpack_public_path__ + "img/hand_side3_49.8cb6efdd.svg";